import React from 'react';
import { useNavigate } from 'react-router-dom';

const Schedule = () => {
  const navigate = useNavigate();

  return (
    <div className="previewTile">
      <div className="featureTitle">Puzzle Schedule</div>
      <div className="scheduleItem">
        <div className="scheduleName">Megarubigram:</div> Tues & Fri
      </div>
      <div className="scheduleItem">
        <div className="scheduleName">Pathword 5x5:</div> Tues & Fri
      </div>
      <div className="scheduleItem">
        <div className="scheduleName">Ultrarubigram:</div> 1st of the month
      </div>
      <div className="scheduleItem">
        <div className="scheduleName">All others:</div> Daily
      </div>
      <div className="lastScheduleItem">Puzzles update at midnight EST.</div>
      <div className="scheduleFootnote">
        Morphology originally ran from September 2025 through the end of July 2026, and the daily Morphologies now are re-runs from that period. A longer post discussing why it ended is available <a
          href="/on-ending-morphology"
          onClick={(e) => {
            // keep the href for styling / open-in-new-tab, but navigate via the
            // SPA router on normal clicks to avoid a full-page reload
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
            e.preventDefault();
            navigate('/on-ending-morphology');
            window.scrollTo(0, 0);
          }}
        >here</a>.
      </div>
    </div>
  );
};

export default Schedule;